<template>
    <canvas ref="chart" width="100" height="100" />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { Chart, type TooltipItem } from "./chart";

const chart = ref<HTMLCanvasElement | null>(null);
const parameters: any = {
    type: "line",
    data: {
        labels: ["Day 0", "Day 15", "Day 31"],
        datasets: [
            {
                label: "Memory Improvement with Placebo",
                data: [0, 5.12, 8.6],
                backgroundColor: "rgba(252, 101, 133, 0.3)",
                borderColor: "rgba(252, 101, 133, 1)",
                borderWidth: 1,
                fill: true,
                tension: 0.4,
            },
            {
                label: "Memory Improvement with RediMind",
                data: [0, 44.81, 51.6],
                backgroundColor: "rgba(24, 140, 251, 0.3)",
                borderColor: "rgba(24, 140, 251, 1)",
                borderWidth: 1,
                fill: true,
                tension: 0.4,
            },
        ],
    },
    options: {
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: function (value: number | string) {
                        return `${value}%`;
                    },
                },
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context: TooltipItem<"line">) {
                        return `${context.dataset.label?.includes("RediMind") ? "RediMind" : "Placebo"} - ${context.formattedValue}%`;
                    },
                },
            },
        },
    },
};

onMounted(() => {
    if (chart.value) {
        new Chart(chart.value, parameters);
    }
});
</script>
